import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Routes } from "../../features/routes/routes.js"
import { Stations } from "../../features/stations/stations.js"
import { DriverMap } from "../../features/driverMap/driverMap.js"
import { DriversOnRoute } from "../../features/driversOnRoute/driversOnRoute.js"
import { getCurrentLocation } from "../../utils/location.js"
import { getCurrentTimeUnixFormat } from "../../utils/formatDate.js"
import {
  getStationsByRoute,
  setShowStations,
  clearStationData,
  clearSessionExpired,
} from "../../features/stations/stationsSlice"
import { Header } from "../../features/common/header/header.js"
import { Orders } from "../../features/orders/orders.js"
import { useNavigate } from "react-router"
import { ButtonWhite } from "../../features/common/buttonWhite/buttonWhite"
import { NotificationPopup } from "../../features/common/notificationPopup/notificationPopup"
import { BarcodeScanner } from "../../features/barcodeScanner/barcodeScanner"
import { ManagerHeader } from "../../features/common/ManagerHeader/managerHeader"
import {
  endDriverRouteSessions,
  setShowRoutes,
  clearEndDriverSessions,
} from "../../features/routes/routesSlice"
import { clearUserData } from "../loginOtpPage/loginOTPSlice"
import {
  setShowDriverMap,
  setCurrentLocation,
  setLocationError,
  setLocationNotEvailable,
} from "../../features/driverMap/driverMapSlice"
import truck from "../../assets/images/truck.png"
import { setShowDriversOnRoute } from "./mainPageSlice.js"
import "./mainPage.scss"

export function MainPage() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    showStations,
    orderDetailsClicked,
    isSessionExpired,
    isTokenExpired,
  } = useSelector((state) => state.stations)
  const { showDriverMap, isLocationError } = useSelector(
    (state) => state.driverMap
  )
  const { showOrders } = useSelector((state) => state.orders)
  const { userData, token } = useSelector((state) => state.loginOTP)
  const { testLatitude, testLongitude, startDayTime, showDriversOnRoute } =
    useSelector((state) => state.main)
  const {
    showRoutes,
    driverCurrentRoute,
    selectedRouteId,
    endDriverSessionSuccess,
  } = useSelector((state) => state.routes)
  const { showScanModal } = useSelector((state) => state.barcodeScanner)
  const [isRefreshRouteBtnDisabled, setRefreshRouteBtnDisabled] =
    useState(false)
  const { isManagerMode } = useSelector((state) => state.main)

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(getPositionSuccess, () =>
      dispatch(setLocationError(true))
    )
  }, [])

  useEffect(() => {
    if (isSessionExpired) {
      dispatch(
        endDriverRouteSessions({
          token: token,
          routeId: selectedRouteId,
        })
      )
    }
  }, [isSessionExpired])

  useEffect(() => {
    if (isLocationError) {
      dispatch(
        setCurrentLocation({
          latitude: process.env.REACT_APP_WAREHOUSE_LATITUDE,
          longitude: process.env.REACT_APP_WAREHOUSE_LONGITUDES,
        })
      )
    }
  }, [isLocationError])

  useEffect(() => {
    if (orderDetailsClicked) {
      refreshStationsByRoute()
    }
  }, [orderDetailsClicked])

  useEffect(() => {
    if (userData == null) {
      navigate("/")
    }
  }, userData)

  useEffect(() => {
    if (driverCurrentRoute !== null) {
      const refreshStationsInterval = setInterval(
        refreshStationsByRoute,
        process.env.REACT_APP_ROUTES_REFRESH_INTERVAL
      )
      return () => {
        clearInterval(refreshStationsInterval)
      }
    }
  }, [driverCurrentRoute, selectedRouteId, testLatitude, testLongitude])

  useEffect(() => {
    if (isManagerMode == false) {
      dispatch(setShowDriverMap(false))
      dispatch(setShowRoutes(true))
      dispatch(setShowStations(false))
      dispatch(setShowDriversOnRoute(false))
    }
  }, [isManagerMode])

  // useEffect(() => {
  //   const getLocationInterval = setInterval(() => {
  //     if (testLatitude && testLongitude) {
  //       dispatch(
  //         setCurrentLocation({
  //           latitude: testLatitude,
  //           longitude: testLongitude,
  //         })
  //       )
  //     } else {
  //       navigator.geolocation.getCurrentPosition(getPosition)
  //     }
  //   }, 10000)
  //   return () => {
  //     clearInterval(getLocationInterval)
  //   }
  // }, [testLatitude, testLongitude])

  useEffect(() => {
    if (isTokenExpired) {
      // dispatch(clearStationData())
      dispatch(clearUserData())
      navigate("/")
      window.location.reload(true)
    }
  }, [isTokenExpired])

  useEffect(() => {
    if (endDriverSessionSuccess) {
      dispatch(setShowDriverMap(false))
      dispatch(setShowRoutes(true))
      dispatch(setShowStations(false))
      dispatch(clearEndDriverSessions())
      if (isSessionExpired == false) {
        dispatch(clearStationData())
        //dispatch(clearUserData())
        navigate("/MainPage")
        //window.location.reload(true)
      }
      dispatch(clearSessionExpired())
      refreshStationsByRoute()
    }
  }, [endDriverSessionSuccess])

  const getPositionSuccess = (position) => {
    dispatch(
      setCurrentLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      })
    )
    dispatch(setLocationError(false))
  }

  const refreshStationsByRouteClicked = () => {
    setRefreshRouteBtnDisabled(true)
    if (navigator.onLine) {
      refreshStationsByRoute()
    }
    setTimeout(() => setRefreshRouteBtnDisabled(false), 10000)
  }

  const refreshStationsByRoute = () => {
    if (testLatitude && testLongitude) {
      dispatch(
        getStationsByRoute({
          token: token,
          routeId: selectedRouteId,
          useStationRouteCache: true,
          latitude: testLatitude,
          longitude: testLongitude,
          startedDayTime: startDayTime
            ? startDayTime
            : getCurrentTimeUnixFormat(),
        })
      )
    } else {
      getCurrentLocation()
        .then((res) => {
          dispatch(setLocationNotEvailable(false))
          dispatch(
            getStationsByRoute({
              token: token,
              routeId: selectedRouteId,
              useStationRouteCache: true,
              latitude: res.coords.latitude,
              longitude: res.coords.longitude,
              startedDayTime: startDayTime
                ? startDayTime
                : getCurrentTimeUnixFormat(),
            })
          )
        })
        .catch(() => {
          dispatch(setLocationNotEvailable(true))
          console.log("error refresh routes")
        })
    }
  }

  return (
    <div className="mainPage-wrapper ">
      <Header />
      {/* {showDriverMap ? (
        <ButtonWhite
          disabled={isRefreshRouteBtnDisabled}
          extraclass={
            "btn-refresh-routes" +
            (isRefreshRouteBtnDisabled ? " btn-refresh-disabled" : "")
          }
          text="רענן תחנות"
          clickHandler={() => refreshStationsByRouteClicked()}
        />
      ) : null} */}
      {userData?.role == "Manager" && showRoutes ? <ManagerHeader /> : null}
      <div
        className={`mainPage-container ${
          showDriverMap ? "vertical" : "horizontal"
        }  `}
      >
        {showDriversOnRoute ? <DriversOnRoute /> : null}
        {showRoutes ? <Routes /> : null}
        {showStations ? (
          <Stations />
        ) : isManagerMode ? null : (
          <div
            className={`parallax ${
              userData?.role === "Manager" ? "isManager" : ""
            }`}
          >
            <img src={truck} className="truck" alt="truck" />
          </div>
        )}
        {showDriverMap ? <DriverMap /> : null}
        {showOrders ? <Orders /> : null}
        {showScanModal ? <BarcodeScanner /> : null}
        <NotificationPopup
          show={isLocationError}
          text={
            <div className="no-location-text">
              <p>
                אין כרגע הרשאות מיקום לדפדפן. זה יגרום למסלול לא להופיע תקין. נא
                לתקן בהגדרות הדפדפן
              </p>
              <p>
                There are currently no location permissions for the browser.
                This will cause the route to not appear correctly. Please
                correct this in your browser settings.
              </p>
            </div>
          }
          close={() => dispatch(setLocationError(false))}
        ></NotificationPopup>
      </div>
    </div>
  )
}
